import React from 'react';

const AboutBox = () => {
    return (
        <div className="about__boxes grid">
            <div className="about__box">
                <i className="about__icon fa-solid fa-paw"></i>

                <div>
                    <h3 className="about_title">223</h3>
                    <span className="about__subtitle">Dog Sitting</span>
                </div>
            </div>

            <div className="about__box">
                <i className="about__icon fa-solid fa-dog"></i>

                <div>
                    <h3 className="about_title">312</h3>
                    <span className="about__subtitle">Dog Walking</span>
                </div>
            </div>

            <div className="about__box">
                <i className="about__icon fa-solid fa-bone"></i>

                <div>
                    <h3 className="about_title">93</h3>
                    <span className="about__subtitle">Dog Hosting</span>
                </div>
            </div>

            <div className="about__box">
                <i className="about__icon fa-solid fa-house"></i>

                <div>
                    <h3 className="about_title">442</h3>
                    <span className="about__subtitle">House Visiting</span>
                </div>
            </div>
        </div>
    );
};

export default AboutBox;
